/**
 * 
 * 线性：描边颜色
 * 面性：填充颜色
 * 双色：描边颜色 + 填充颜色
 * 多色：外部描边颜色 + 外部填充颜色 + 内部描边颜色 + 内部填充颜色
 * 
// 描边连接类型
export type StrokeLinejoin = 'miter' | 'round' | 'bevel';

// 描边端点类型
export type StrokeLinecap = 'butt' | 'round' | 'square';

// 主题
export type Theme = 'outline' | 'filled' | 'two-tone' | 'multi-color';
 * 
 */

const base = {
    size: 16,
    strokeWidth: 4,
    strokeLinecap: 'butt',
    strokeLinejoin: 'miter',
}

function initColors(
    theme, 
    customColor = ['#000000', '#000000', '#000000', '#000000'], 
    isCurrentColor = true) {
    const colors = Array(3).fill(customColor[0]);
    // 以下为留白逻辑
    // 线性
    if (theme === 'outline') {
        colors[0] = isCurrentColor ? 'currentColor' : customColor[0];
        colors[1] = '#ffffff';
        colors[2] = isCurrentColor ? 'currentColor' : customColor[0];
    }
    // 面性
    if (theme === 'filled') {
        colors[0] = isCurrentColor ? 'currentColor' : customColor[1];
        colors[1] = isCurrentColor ? 'currentColor' : customColor[1];
        colors[2] = '#ffffff';
    }
    // 双色
    if (theme === 'two-tone') {
        colors[0] = customColor[0];
        colors[1] = customColor[1];
        colors[2] = customColor[0];
    }
    // 多色
    if (theme === 'multi-color') {
        colors[0] = customColor[0];
        colors[1] = customColor[1];
        colors[2] = customColor[2];
    }
    return colors;
}

function initSize(size, isFontSize = false) {
    return isFontSize ? '1em' : `${size}px`;
}

export default {
    name: 'commonIconClose2',
    cName: '关闭2',
    render(config) {
        const props = {
            ...base,
            ...config,
            size: initSize(config.size, config.isFontSize),
            colors: initColors(config.theme, config.colors, config.isCurrentColor)
        }
        return this.svgFn(props);
    },
    svgFn: (props) => (
        `
        <svg width="${props.size}" height="${props.size}" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fill-rule="evenodd">
                <g stroke="${props.colors[0]}" stroke-linecap="${props.strokeLinecap}" stroke-width="${props.strokeWidth}">
                    <path d="M12 12l24 24M36 12L12 36"/>
                </g>
            </g>
        </svg>
        `
    )
};
